<template>
    <v-dialog max-width="600">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
                outlined
                small
            >
                Visualizar comprovante
                <v-icon size="small" class="ml-2">
                    mdi-eye
                </v-icon>
            </v-btn>
        </template>
        <v-card class="pa-6">
            <v-card-text class="d-flex flex-column receipt-body">
                <div class="d-flex flex-column align-center">
                    <v-img src="/images/OnflyLogo.png" width="150px" contain class="mx-auto py-4" />
                    <h2>TRANSFERÊNCIA PIX REALIZADA</h2>
                    <span class="color-gray-6">{{ `${pixDate}, via app Itaú` }}</span>
                </div>
                <br>
                <span>Valor:</span>
                <span class="font-weight-bold">R$ {{ booking.total_value }}</span>
                <br>
                <span>De:</span>
                <span class="font-weight-bold">ONFLY TECNOLOGIA LTDA</span>
                <span class="font-weight-bold">Itaú Unibanco S.A. - 2977/206461</span>
                <br>
                <span>Para:</span>
                <span class="font-weight-bold">{{ booking.hotel.name }}</span>
                <span class="font-weight-bold">{{ booking.payment.institution }}</span>
                <br>
                <span>Descrição:</span>
                <span class="font-weight-bold">Reservas de hotel.</span>
                <br>
                <span>ID da transação:</span>
                <span class="font-weight-bold">{{ booking.payment.transaction_id }}</span>
                <br>
                <span>Chave PIX:</span>
                <span class="font-weight-bold">{{ booking.payment.pix_key }}</span>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ShowPixReceipt",
    props: ['booking'],
    computed: {
        pixDate() {
            const dateObj = new Date(this.booking.payment.updated_at);

            const day = ('0' + dateObj.getDate()).slice(-2);
            const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
            const year = dateObj.getFullYear();
            const hours = ('0' + dateObj.getHours()).slice(-2);
            const minutes = ('0' + dateObj.getMinutes()).slice(-2);
            const seconds = ('0' + dateObj.getSeconds()).slice(-2);

            return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        }
    },
}
</script>

<style scoped>
.receipt-body {
    background: #f0f0f0;
    border-radius: 10px !important;
    padding: 20px;
}
</style>
